const PARALLEL_MESSAGE_SEGMENT = ":parallel:";

export const getParallelBranchIdFromMessageId = (
  messageId: string | null | undefined
): string | null => {
  if (!messageId) {
    return null;
  }

  const markerIndex = messageId.indexOf(PARALLEL_MESSAGE_SEGMENT);

  if (markerIndex === -1) {
    return null;
  }

  const branchId = messageId
    .slice(markerIndex + PARALLEL_MESSAGE_SEGMENT.length)
    .split(":")[0]
    ?.trim();

  return branchId && branchId.length > 0 ? branchId : null;
};
